
import {notificationIconStyles, notificationCloseStyles, notificationMessageStyles, notificationContentStyles, notificationContainerStyles, notificationStyles, notificationErrorStyles, notificationWarningStyles} from "./styles";

const NotificationContainer = ({notifications, removeNotification}) => {
    return (
        <div style={{...notificationContainerStyles}}>
            {notifications.map(notification => (
                <div
                    key={notification.id}
                    style={{
                        ...notificationStyles,
                        ...(notification.type === 'error' ? notificationErrorStyles : {}),
                        ...(notification.type === 'warning' ? notificationWarningStyles : {}),
                    }}
                    onClick={() => removeNotification(notification.id)}
                >
                    <div style={notificationContentStyles}>
                        <span style={notificationIconStyles}>
                        {notification.type === 'success' ? '✅' : 
                        notification.type === 'error' ? '❌' : 
                        notification.type === 'warning' ? '⚠️' : 'ℹ️'}
                        </span>
                        <span style={notificationMessageStyles}>{notification.message}</span>
                    </div>
                    <button style={notificationCloseStyles} onClick={(e) => {
                        e.stopPropagation();
                        removeNotification(notification.id);
                    }}>
                        ×
                    </button>
                </div>
            ))}
        </div>
    );
};
export default NotificationContainer;